import log from 'loglevel';
import {all, put, takeEvery, takeLatest} from 'redux-saga/effects';
import {fetchError, fetchStart, fetchSuccess} from 'shared/actions';
import vegetationActions, {
  LEGEND_COLOR_CASE,
  LEGEND_COLOR_CASE_LAI,
  LEGEND_COLOR_CASE_NDVI_PLANET,
  LegendColorCaseAction,
  LegendColorCaseLaiAction,
  LegendColorCaseNdviPlanetAction,
} from '../actions/VegetationActions';

function* legendColorCase(action: LegendColorCaseAction) {
  try {
    yield put(fetchStart('legendColorCase'));
    const data = action.payload;
    yield put(vegetationActions.legendColorCaseSuccess(data));
    yield put(fetchSuccess('legendColorCase'));
  } catch (error: any) {
    log.error(error);
    yield put(fetchError('legendColorCase', error));
  }
}

function* legendColorCaseLai(action: LegendColorCaseLaiAction) {
  try {
    yield put(fetchStart('legendColorCase'));
    const data = action.payload;
    yield put(vegetationActions.legendColorCaseSuccess(data));
    yield put(fetchSuccess('legendColorCase'));
  } catch (error: any) {
    log.error(error);
    yield put(fetchError('legendColorCase', error));
  }
}
function* legendColorCaseNdviPlanet(action: LegendColorCaseNdviPlanetAction) {
  try {
    yield put(fetchStart('legendColorCase'));
    const data = action.payload;
    yield put(vegetationActions.legendColorCaseSuccess(data));
    yield put(fetchSuccess('legendColorCase'));
  } catch (error: any) {
    log.error(error);
    yield put(fetchError('legendColorCase', error));
  }
}

export function* vegetationSagas() {
  yield all([takeLatest(LEGEND_COLOR_CASE, legendColorCase)]);
  yield all([takeEvery(LEGEND_COLOR_CASE_LAI, legendColorCaseLai)]);
  yield all([takeEvery(LEGEND_COLOR_CASE_NDVI_PLANET, legendColorCaseNdviPlanet)]);
}
